import React from 'react';
import Table from 'components/Table/index';
import Button from 'components/Button';
import * as S from './styles';
import { columnsGridPerformance, montarLinhaGridPerformance } from './columns';

const tabelaRelDetalhadaPerformance = ({ dadosGrid, dadosGrafico, mostrarDados }) => {
  return (
    <>
      {dadosGrafico && (
        <Button css={{ justifyContent: 'start' }} text={'Detalhar Dados'} clickAction={() => mostrarDados()} />
      )}
      {dadosGrid?.length > 0 &&
        dadosGrafico !== null &&
        dadosGrid.map(periodo => {
          return (
            <S.ContainerTabela key={periodo.anoReferencia}>
              <Table
                columns={columnsGridPerformance}
                data={montarLinhaGridPerformance(periodo.atendentes).sort((a, b) => a.key - b.key)}
              />
            </S.ContainerTabela>
          );
        })}
    </>
  );
};

export default tabelaRelDetalhadaPerformance;
// $$$ ID:  01/01/2022 - 31/12/2024
